<div> 
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('VMM')" [class]="botonactivo.vmm">VMM</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('VMM-otros')" [class]="botonactivo.vmmOtros">VMM-otros</button>
        </div>
         <div class="col">
          <button type="button" (click)="seleccionaCuenca('VMM - SR & TSQ')" [class]="botonactivo.vmmOtros">VMM - SR & TSQ</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Putumayo norte')"[class]="botonactivo.putNorte">Put.Norte</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Putumayo sur')" [class]="botonactivo.putSur">Put.Sur</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Bogota')" [class]="botonactivo.bogota">Bogotá</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Nacional')" [class]="botonactivo.nacional">Nacional</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Ecuador')" [class]="botonactivo.ecuador">Ecuador</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Charapa')" [class]="botonactivo.charapa">Charapa</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Chanangue')" [class]="botonactivo.chanangue">Chanangue</button>
        </div>
        <div class="col">
          <button type="button" (click)="seleccionaCuenca('Iguana')" [class]="botonactivo.iguana">Iguana</button>
        </div>

      </div>
    </div>
  </div>
</div>



<!-- los iconos salen de aqui: https://avmaisak.github.io/ngx-bootstrap-icons/home -->

<bi name="check-circle-fill" style="color: green;"></bi>Aprobado 
<bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi>Pendiente de aprobación
<bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi>Denegado
<bi name="x-circle" style="color: rgb(10, 111, 170);"></bi>N/A
<bi name="info-circle-fill" style="color: rgb(10, 111, 170);"></bi>Detalles
<p>Última actualización: {{ultimaActualizacion}}</p>

<div *ngIf="alertaActiva">
  <ngb-alert #selfClosingAlert  type="warning" >
     <div class="spinner-border" role="status">
       <span class="sr-only"></span>
     </div>
     Actualizando...
   </ngb-alert>
</div>



<div  color="light" style="margin: 10px;">
  <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="display compact " id="tabla" >
    <thead>
      <tr>
        <th><small>Ver</small></th>
        <th><small>Ais</small></th>
        <th><small>HSE</small></th>
        <th><small>AA</small></th>
        <th><small>GC</small></th>
        <th><small>AAL</small></th>
        <th><small>Ticket</small></th>
        <th><small>Status</small></th>
        <th><small>Descripción</small></th>
        <th><small>FechaInicio</small></th>
        <th><small>FechaFinal</small></th>
        <th><small>Locación</small></th>
        <th><small>Unidad</small></th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of arraydeposts">
        <td>
          <button (click)="detalle(item.data())"><span><bi name="info-circle-fill" style="color: rgb(10, 111, 170);"></bi></span></button>
        </td>
        <td>
          <small *ngIf="item.data().dictamenAutAislante.vistobueno == true"> <span><bi name="check-circle-fill" style="color: green;"></bi></span> </small>
          <small *ngIf="item.data().requiereAutoridadAislante == true && item.data().dictamenAutAislante.vistobueno == false && item.data().dictamenAutAislante.comentario == '' "> <span><bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi></span></small>
          <small *ngIf="item.data().requiereAutoridadAislante == true && item.data().dictamenAutAislante.vistobueno == false && item.data().dictamenAutAislante.comentario != '' "> <span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></small>
          <small *ngIf="item.data().requiereAutoridadAislante == false || item.data().requiereAutoridadAislante == undefined "> <span><bi name="x-circle" style="color: rgb(10, 111, 170);"></bi></span></small> 
        </td>
        <td>
          <small *ngIf="item.data().dictamenAutHSE.vistobueno == true"> <span><bi name="check-circle-fill" style="color: green;"></bi></span></small>
          <small *ngIf="item.data().dictamenAutHSE.vistobueno == false && item.data().dictamenAutHSE.comentario == ''"> <span><bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi></span></small>
          <small *ngIf="item.data().dictamenAutHSE.vistobueno == false && item.data().dictamenAutHSE.comentario != '' "> <span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></small>
        </td>
        <td>
          <small *ngIf="item.data().dictamenAutArea.vistobueno == true"> <span><bi name="check-circle-fill" style="color: green;"></bi></span></small>
          <small *ngIf="item.data().dictamenAutArea.vistobueno == false && item.data().dictamenAutArea.comentario == ''"> <span><bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi></span></small>
          <small *ngIf="item.data().dictamenAutArea.vistobueno == false && item.data().dictamenAutArea.comentario != '' "> <span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></small>
        </td>
        <td>
          <small *ngIf="item.data().dictamenGerenteCampo.vistobueno == true"> <span><bi name="check-circle-fill" style="color: green;"></bi></span> </small>
          <small *ngIf="item.data().requiereGerenteCampo == true && item.data().dictamenGerenteCampo.vistobueno == false && item.data().dictamenGerenteCampo.comentario == '' "> <span><bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi></span></small>
          <small *ngIf="item.data().requiereGerenteCampo == true && item.data().dictamenGerenteCampo.vistobueno == false && item.data().dictamenGerenteCampo.comentario != '' "> <span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></small>
          <small *ngIf="item.data().requiereGerenteCampo == false || item.data().requiereGerenteCampo == undefined "> <span><bi name="x-circle" style="color: rgb(10, 111, 170);"></bi></span></small> 
        </td>
        <td>
          <small *ngIf="item.data().dictamenAutAreaLocal.vistobueno == true"> <span><bi name="check-circle-fill" style="color: green;"></bi></span></small>
          <small *ngIf="item.data().dictamenAutAreaLocal.vistobueno == false && item.data().dictamenAutAreaLocal.comentario == '' "> <span><bi name="question-circle-fill" style="color: rgb(230, 207, 7);"></bi></span></small>
          <small *ngIf="item.data().dictamenAutAreaLocal.vistobueno == false && item.data().dictamenAutAreaLocal.comentario != '' "> <span><bi name="x-circle-fill" style="color: rgb(173, 10, 10);"></bi></span></small>
        </td>

        <td><small>{{(item.id.substr(item.id.length - 6))}}</small></td>
        <td><small>{{item.data().status}}</small></td>
        <td><small>{{(item.data().descripcionPTW).substring(0,80)}}</small></td>
        <td><small>{{item.data().fechainicio}}</small></td>
        <td><small>{{item.data().fechafinal}}</small></td>
        <td><small>{{item.data().pozoSeleccionado}}</small></td>
        <td><small>{{item.data().unidadDeNegocio}}</small></td>
      </tr>
      
    </tbody>
  </table>

 </div>
